import { render } from "./NUEZ.vue?vue&type=template&id=7500037c"
import script from "./NUEZ.vue?vue&type=script&lang=js"
export * from "./NUEZ.vue?vue&type=script&lang=js"
script.render = render

export default script